import React from 'react'
import cn from 'classnames'

import { BoxHeadline, Label } from 'shared/ui'
import { isEmpty } from 'util/objects'
import { propFunc } from 'util/functions'

import DirectionToggle from './DirectionToggle'
import styles from './styles.css'

const MergeHeader = props => {
  const { ticket, direction, onSwap } = props
  if (!ticket || isEmpty(ticket)) return null

  return (
    <div className={cn('grui ml-12', styles.headerWrapper)}>
      <Label as="div" className="grui mt-10" size="large">
        Merge Conversation
      </Label>
      <BoxHeadline as="div" className="grui mt-4" color="gray" key={ticket.id}>
        {ticket.title}
      </BoxHeadline>
      <DirectionToggle
        direction={direction}
        onClick={propFunc(onSwap, ticket.id)}
      />
    </div>
  )
}

export default MergeHeader
